import { render, staticRenderFns } from "./ErrorContentDetail.vue?vue&type=template&id=7854a522&scoped=true&"
import script from "./ErrorContentDetail.vue?vue&type=script&lang=js&"
export * from "./ErrorContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContentDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ErrorContentDetail.vue?vue&type=style&index=1&id=7854a522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854a522",
  null
  
)

export default component.exports